export default "__VITE_PUBLIC_ASSET__b2ec72d0__"